import { styled } from '@mui/material'

export const StyledFooter = styled('footer')({
  backgroundColor: 'var(--white)',
  padding: '19px 0',
  borderTop: '1px solid var(--border)'
})
